import { render, staticRenderFns } from "./EditFolderModal.vue?vue&type=template&id=1e0df8ef&scoped=true&"
import script from "./EditFolderModal.vue?vue&type=script&lang=ts&"
export * from "./EditFolderModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditFolderModal.vue?vue&type=style&index=0&id=1e0df8ef&prod&scoped=true&lang=css&"
import style1 from "./EditFolderModal.vue?vue&type=style&index=1&id=1e0df8ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0df8ef",
  null
  
)

export default component.exports